<app-loading *ngIf="contentReady"></app-loading>
<div class="container-fluid p-0">
  <div>


    <div class="col-12 col-sm-12 main-content">
      <div class="container-fluid mb-4">
        <div class="categoryContainer">

            <div class="col-12">
            <button routerLink="/createdataflow" style="margin-left: 0;" class="first-btn btn btn-primary">
              {{ 'Create Client' | translate }}
            </button>
            <button routerLink="/pricelist" style="margin-left: 0;" class="first-btn btn btn-primary">
              قائمة الأسعار
            </button>
            <!-- <button (click)="exportToExcel()" class="btn first-btn btn-primary">
              {{ "export to excel" | translate }}
            </button> -->

            <button (click)="getAllClients(10, 1)" style="margin-left: 0;" class="first-btn btn btn-primary">
              {{ 'refresh' | translate }}
            </button>
            <div class="input-group mb-3">
              <input type="text" class="form-control" [(ngModel)]="searchKey"
                placeholder="ابحث برقم الهاتف او الاسم" aria-label="Recipient's username"
                aria-describedby="basic-addon2">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="search()" type="button">{{ 'Search' | translate
                  }}</button>
              </div>
            </div>



          </div>
        </div>
        <div>
          <table mat-table id="Clients" [dataSource]="dataSource" class="mat-elevation-z8">

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>{{ 'Name' | translate }}</th>
              <td mat-cell *matCellDef="let el">{{ el.name }}
                <br>
                <span style="color: red; font-size: 10px;">{{el.notes}}</span>

              </td>
            </ng-container>

            <ng-container matColumnDef="user">
              <th mat-header-cell *matHeaderCellDef>حساب ممارس بلس</th>
              <td mat-cell *matCellDef="let el">
             <b style="color: #4a792b;"> {{ 'Email' | translate }} </b>
                {{ el.email }}

                <br>
             <b style="color: #4a792b;"> {{ 'Password' | translate }} </b>
                {{ el.password }}

                <br>

              </td>
            </ng-container>



            <ng-container matColumnDef="password">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let el">{{ el.password }}</td>
            </ng-container>

            <ng-container matColumnDef="mobile">
              <th mat-header-cell *matHeaderCellDef>{{ 'Phone Number' | translate }}</th>
              <td mat-cell *matCellDef="let el">{{ el.mobile }}

              </td>
            </ng-container>





            <ng-container matColumnDef="register_date">
              <th mat-header-cell *matHeaderCellDef>تاريخ التسجيل</th>
              <td mat-cell *matCellDef="let el">{{ el.register_date | date }}</td>
            </ng-container>

            <ng-container matColumnDef="final_reg">
              <th mat-header-cell *matHeaderCellDef>التصنيف النهائي</th>
              <td mat-cell *matCellDef="let el">
             <b style="color: #4a792b;">بالجنيه المصري</b>
                {{ el.final_reg_egp }}
                <br>
             <b style="color: #4a792b;">بالريال السعودي</b>
                {{ el.final_reg_sar }}
                <br>
             <b style="color: #4a792b;">الدفع</b>
                {{ el.final_reg_pay_method }}
              </td>
            </ng-container>
            <ng-container matColumnDef="first_class">
              <th mat-header-cell *matHeaderCellDef>التسجيل المهني</th>
              <td mat-cell *matCellDef="let el">
             <b style="color: #4a792b;">بالجنيه المصري </b>
                {{ el.first_class_egp }}
                <br>
             <b style="color: #4a792b;">بالريال السعودي</b>
                {{ el.first_class_sar }}
                <br>
             <b style="color: #4a792b;"> طريقة الدفع</b>
                {{ el.first_class_pay_method }}
              </td>
            </ng-container>
            <ng-container matColumnDef="eligibility_res">
              <th mat-header-cell *matHeaderCellDef>حجز رقم أحقية</th>
              <td mat-cell *matCellDef="let el">
             <b style="color: #4a792b;">بالجنيه المصري</b>
                {{ el.eligibility_res_egp }}
                <br>
             <b style="color: #4a792b;">بالريال السعودي</b>
                {{ el.eligibility_res_sar }}
                <br>
             <b style="color: #4a792b;">الدفع</b>
                {{ el.eligibility_res_pay_method }}
              </td>
            </ng-container>
            <ng-container matColumnDef="university">
              <th mat-header-cell *matHeaderCellDef> رسوم الجامعة</th>
              <td mat-cell *matCellDef="let el">
             <b style="color: #4a792b;">بالجنيه المصري</b>
                {{ el.university_fees_egp }}

                <br>
             <b style="color: #4a792b;">بالريال السعودي</b>
                {{ el.university_fees_sar }}

                <br>
             <b style="color: #4a792b;">الدفع</b>
                {{ el.university_fees_pay_method }}

              </td>
            </ng-container>
            <ng-container matColumnDef="dataflow">
              <th mat-header-cell *matHeaderCellDef>الداتا فلو</th>
              <td mat-cell *matCellDef="let el">
             <b style="color: #4a792b;">بالجنيه المصري</b>
                {{ el.dataflow_egp }}

                <br>
             <b style="color: #4a792b;">بالريال السعودي</b>
                {{ el.dataflow_sar }}

                <br>
             <b style="color: #4a792b;">الدفع</b>
                {{ el.dataflow_pay_method }}

              </td>
            </ng-container>
            <ng-container matColumnDef="call">
              <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'call' | translate }}</th>
              <td mat-cell *matCellDef="let el" class="text-center">
                <a class="chat" (click)="call(el.phone_number)">
                  <img src="/assets/call.png" alt="Call">
                </a>
              </td>
            </ng-container>

            <!-- Chat -->
            <ng-container matColumnDef="chat">
              <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'chat' | translate }}</th>
              <td mat-cell *matCellDef="let el" class="text-center">
                <a class="chat" (click)="chat(el.phone_number)">
                  <img src="/assets/chat.png" alt="Chat">
                </a>
              </td>
            </ng-container>

            <!-- Call -->



            <ng-container matColumnDef="options">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let element">

                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">


                    <li><a class="dropdown-item" (click)='edit(element)'>
                        {{ "Edit" | translate }} </a></li>

        @if(isAdmin){
                    <li><a class="dropdown-item" (click)='delete(element.id)'>{{ "Delete" | translate }}</a></li>
        }
                  </ul>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

          <mat-paginator
            style="margin-top: 20px; background: #f5f5f5; border: 1px solid #ddd; border-radius: 6px; padding: 10px;"
            [length]="totalItems" [pageSize]="10" (page)="onPaginateChange($event)">
          </mat-paginator>

        </div>

        <div class="row">
          @if (noData) {
          <app-nodata></app-nodata>
          }
        </div>
      </div>
    </div>
  </div>
</div>